<template>
  <div v-if="media" class="mt-4 w-full">
    <div class="rounded-lg overflow-hidden shadow-sm border border-gray-200 w-full">
      <img
        v-if="media.type === 'image'"
        :src="media.src"
        class="w-full md:h-[500px] h-54 object-cover"
      />
      <video
        v-else-if="media.type === 'video'"
        class="w-full md:h-[500px] h-54 object-cover"
        controls
        :src="media.src"
      ></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostMedia',
  props: {
    media: {
      type: Object,
      default: null,
    },
  },
}
</script>
